export const cities = {
  'lille': {
    label: 'Lille',
    geoloc: 'Lille,%20France_50.62925_3.057256',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'paris': {
    label: 'Paris',
    geoloc: 'Paris,%20France_48.856614_2.3522219',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'lyon': {
    label: 'Lyon',
    geoloc: 'Lyon,%20France_45.764043_4.835659',
    language: 'fr',
    'interior-decorator': false,
    'interior-architect': false
  },
  'nice': {
    label: 'Nice',
    geoloc: 'Nice,%20France_43.7101728_7.261953200000001',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'bordeaux': {
    label: 'Bordeaux',
    geoloc: 'Bordeaux,%20France_44.837789_-0.57918',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'toulouse': {
    label: 'Toulouse',
    geoloc: 'Toulouse,%20France_43.604652_1.444209',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'nantes': {
    label: 'Nantes',
    geoloc: 'Nantes,%20France_47.218371_-1.553621',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'annecy': {
    label: 'Annecy',
    geoloc: 'Annecy,%20France_45.8990887_6.1295411',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'marseille': {
    label: 'Marseille',
    geoloc: 'Marseille,%20France_43.296482_5.36978',
    'interior-decorator': true,
    'interior-architect': true
  },
  'montpellier': {
    label: 'Montpellier',
    geoloc: 'Montpellier,%20France_43.610769_3.876716',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'bayonne': {
    label: 'Bayonne',
    geoloc: 'Bayonne,%20France_43.492949_-1.474841',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': false
  },
  'biarritz': {
    label: 'Biarritz',
    geoloc: '64200%20Biarritz,%20France_43.4831519_-1.558626',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'nimes': {
    label: 'Nimes',
    geoloc: 'N%25C3%25AEmes,%20France_43.836699_4.360054',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'toulon': {
    label: 'Toulon',
    geoloc: 'Toulon,%20France_43.124228_5.928',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'aix-en-provence': {
    label: 'Aix en provence',
    geoloc: 'Aix-en-Provence,%20France_43.529742_5.447426999999999',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
  'strasbourg': {
    label: 'Strasbourg',
    geoloc: 'Strasbourg,%20France_48.5734053_7.752111299999999',
    language: 'fr',
    'interior-decorator': true,
    'interior-architect': true
  },
};
